import { PurePagePlugin } from './plugins/pure-page';

if (typeof window !== 'undefined' && (window as any).AliTranslate) {
  (window as any).AliTranslate.registerPlugin('page', PurePagePlugin);
}
